import { ConnectivityStatus } from '../connectivityStatus';
import { FlightRoomRole } from './flightRoomRole';
import { JobTitle } from './jobTitle';

export enum FlightRoomUserStatus {
  JOINED = 'joined',
  PENDING = 'pending',
  SCHEDULED = 'scheduled',
  UNKNOWN = 'unknown', // Internal only
}

export type FlightRoomUser = {
  account: string;
  connectivityStatus: ConnectivityStatus;
  email: string | null;
  externalId: string;
  firstName: string | null;
  id: string;
  jobTitle: JobTitle;
  jobTitleCustom: string | null;
  lastName: string | null;
  phoneNumber?: string;
  rank?: string;
  roles: FlightRoomRole[];
  status: FlightRoomUserStatus;
  userName: string;
};
